module.exports = __webpack_public_path__ + "static/media/arrow-down.37cb862e.svg";